import { isNil } from 'lodash';
import { action, makeAutoObservable, runInAction } from 'mobx';
import * as shopService from 'services/shopService';
import type RootStore from './rootStore';
import type { Shop } from 'models/shop/shop';

export default class ShopStore {
  shop?: Shop;

  constructor(public rootStore: RootStore) {
    makeAutoObservable(this);
  }

  updateShopInfo = action((): void => {
    if (isNil(this.rootStore.userStore.userData)) {
      this.shop = undefined;
      return;
    }

    shopService
      .getShopAsync(this.rootStore.userStore.userData.shopId)
      .then((s) => {
        runInAction(() => {
          this.shop = s;
        });

        return s;
      })
      .catch(console.log);
  });
}
